import { render, staticRenderFns } from "./XZ.vue?vue&type=template&id=1452858c&scoped=true&"
import script from "./XZ.vue?vue&type=script&lang=js&"
export * from "./XZ.vue?vue&type=script&lang=js&"
import style0 from "./XZ.vue?vue&type=style&index=0&id=1452858c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452858c",
  null
  
)

export default component.exports